// A database's TimescaleDB background jobs (System > database > Maintenance): NextAdmin `tables/basic-tables`.
import { Badge, Card, DataTable, type DataTableColumn } from '../../../components/ui/index.js';
import type { SystemDatabase } from '../../../generated/api/types.gen.js';
import { formatCount, formatSeconds } from './metric-format.js';

type Job = SystemDatabase['jobs'][number];

const JOB_COLUMNS: DataTableColumn<Job>[] = [
  { key: 'name', header: 'Job', render: (j) => j.name },
  { key: 'relation', header: 'Table', render: (j) => <span className="font-mono text-xs">{j.relation || '—'}</span> },
  {
    key: 'scheduled',
    header: 'State',
    render: (j) => (
      <Badge variant={j.scheduled ? 'success' : 'warning'} dot>
        {j.scheduled ? 'Scheduled' : 'Paused'}
      </Badge>
    ),
  },
  {
    key: 'status',
    header: 'Last run',
    render: (j) => (
      <Badge variant={j.lastOk ? 'success' : 'danger'} dot>
        {j.lastOk ? 'Succeeded' : 'Failed'}
      </Badge>
    ),
  },
  { key: 'failures', header: 'Failures', align: 'right', render: (j) => formatCount(j.failures) },
  {
    key: 'overdue',
    header: 'Overdue',
    align: 'right',
    render: (j) => (j.overdueSeconds > 0 ? formatSeconds(j.overdueSeconds) : '—'),
  },
];

export function JobsCard({ jobs }: { jobs: Job[] }) {
  return (
    <Card title="TimescaleDB jobs" className="xl:col-span-12">
      <DataTable
        columns={JOB_COLUMNS}
        rows={jobs}
        rowKey={(j) => `${j.name}:${j.relation}`}
        getRowAttention={(j) => (!j.lastOk ? 'danger' : j.overdueSeconds > 3_600 ? 'warning' : undefined)}
      />
    </Card>
  );
}
